import { OrganizationSubjects as CommonOrganizationSubjects } from '../common/enums/OrganizationSubjects'

export class OrganizationSubjects extends CommonOrganizationSubjects {
  static Gko = 'gko'
}
